
import store from '@/store';
import prevent from '@/logic/helpers/inputs/prevent';

export default {
  name: 'VatNumberInput',

  model: {
    prop: 'vatNumber',
    event: 'input',
  },

  props: {
    vatCountryCodeAsProp: {
      type: String,
      default: '',
    },
    mandatory: {
      type: Boolean,
      default: true,
    },
  },

  data(): Record<string, unknown> {
    return {
      vatCountryCode: '',
      vatNumber: '',
      initialEmitWithCountryCodeDone: false,
      device: store.state.device,
    };
  },

  computed: {
    fullVat(): string {
      const fullVat = this.vatNumber ? `${this.vatCountryCode}${this.vatNumber}` : '';

      return fullVat;
    },

    parentCompVatNumber(): string {
      return this.$attrs.vatNumber;
    },
  },

  watch: {
    parentCompVatNumber(): void {
      if (!this.parentCompVatNumber) return;

      this.vatCountryCode = this.parentCompVatNumber.slice(0, 2);
      this.vatNumber = this.parentCompVatNumber.slice(2);
    },

    vatCountryCodeAsProp(): void {
      const userHasDifferentCountryCode = /^[A-Z]{2}/.test(this.parentCompVatNumber.slice(0, 2));

      if (!this.vatCountryCodeAsProp || userHasDifferentCountryCode) {
        return;
      }

      this.vatCountryCode = this.vatCountryCodeAsProp;
    },

    fullVat(): void {
      if (!this.initialEmitWithCountryCodeDone) {
        this.initialEmitWithCountryCode();
        return;
      }

      this.$emit('input', this.fullVat);
    },
  },

  methods: {
    initialEmitWithCountryCode(): void {
      const fullVatBeginsWithCountryCode: boolean = /^[A-Z]{2}\w+$/g.test(this.fullVat);

      if (!fullVatBeginsWithCountryCode) return;

      this.initialEmitWithCountryCodeDone = true;
    },

    sanitizeVatCountryCode(val: string): void {
      val = val.toUpperCase();

      this.vatCountryCode = prevent.nonCapitalLetterChars(val);
    },
  },
};
